import Vue from 'vue';
import users from '../../users';
import axios from 'axios';

export default {
  name: 'changeEmailComplete',
  mixins: [users],
  data: function () {
    return {
      message: '',
      isError: false,
      redirectBottomeOffset1: null,
      windowHeight: window.innerHeight,
      redirect: false,
      homeButtonUrl: '',
    }
  },
  computed: {
    messageClass: function () {
      return this.isError ? 'error-class' : '';
    },
    redirectBottomeOffset: function () {
      let temp = this.windowHeight - 20;
      return `position: fixed; top: ${temp}px; width: 100px;`;
    },
  },
  created() {
    this.getSettings();
  },
  mounted() {
    window.addEventListener('resize', () => this.windowHeight = window.innerHeight);
    var code = this.$route.params.code;
    this.confirmLink(code);
  },
  beforeUnmount() {
    window.removeEventListener('resize', () => this.windowHeight = window.innerHeight);
    this.timer.clearTimeout()
  },
  methods: {
    goToHome() {
      if (this.homeButtonUrl)
        window.location.href = this.homeButtonUrl;
    },
    redirectLogin() {
      this.$router.push('/login');
    },
    logout() {
      axios.post('/account/Logout')
        .finally(this.redirectLogin());
    },
    confirmLink(code) {
      if (!code || code == '') {
        this.redirectLogin();
        return;
      }

      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ChangeEmailComplete', { Value: code })
        .then(response => {
          if (response.status == 200 && (!response.data || response.data.data.status == 0)) {
            this.setMessage(this.$t('login.ChangeEmailSuccess'));
          }
          else {
            this.setMessage(response.data.data.text, true);
          }
          this.$root.$emit('enable_disable_loader', false);
        })
        .catch(e => {
          this.redirect = false;
          this.setMessage(`Error: ${e.response.data}`, true);
          this.$root.$emit('enable_disable_loader', false);
        });      
    },
    setMessage(msg, isError = false) {
      if (msg == null || msg == '') {
        this.message = msg;
        this.isError = false;
        return;
      }

      this.message = msg;
      this.isError = isError;
    },
    goToHomepage() {
      window.location.href = this.homeURL;
    },
    getSettings() {
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.homeButtonUrl = response.data.value.homeButtonUrl;
          }
        })
        .catch(err => {
          err.data == undefined ?
            this.showMessage(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`, 2) :
            this.showMessage(err.data.data.text, 2)
          this.homeButtonUrl = '';
        })
        .finally(this.$root.$emit('enable_disable_loader', false));
    },
  },
}
